import { Search } from "@/components/Icon/Search";
import { Link, NextImage, Popover, PopoverContent, PopoverTrigger, cn, transMoney, useI18n, useProduct, useSuggestions, } from "@jog/react-components";
const SearchItem = ({ item }) => {
    const { isDiscount, price, firstPrice, linkItem, image, name } = useProduct(item);
    const { $t } = useI18n();
    const _name = name.replace(/^./, (v) => v.toUpperCase());
    return (<div className="relative flex items-center px-3 py-2 text-sm hover:bg-gray-bg hover:text-orange-main">
            <div className="shrink-0 p-2">
                <NextImage blur={false} height={80} width={54} src={image} alt={`${_name} image`}/>
            </div>
            <div className="h-25 flex-1 p-2">
                <div>{_name}</div>
                <div className="mt-1.5">
                    <div className={cn(isDiscount ? "text-red-main" : "text-black", "font-primary text-lg font-bold")}>
                        {transMoney(price * 100, false)}
                    </div>
                    {isDiscount ? (<div className="text-10 text-grey-dark">
                            {$t(`old price`)}: {transMoney(+firstPrice * 100, false)}
                        </div>) : null}
                </div>
            </div>
            <Link href={linkItem} className="absolute inset-0" aria-label={_name}/>
        </div>);
};
export const Suggestions = () => {
    var _a, _b, _c, _d;
    const { $t } = useI18n();
    const { handleSearch, suggestions, isSearchShown, searchTerm, setSearchTerm, setIsSearchShown } = useSuggestions();
    return (<div className="flex h-full w-full items-center justify-end">
            <form onSubmit={async (e) => {
            e.preventDefault();
            await handleSearch(searchTerm);
        }} className="flex w-full border-b-grey-icon bg-gray-light p-2 lg:relative lg:ml-4 lg:w-auto lg:border-b lg:bg-white lg:p-0">
                <button className="bg-green-main p-1 lg:bg-white lg:p-1.5" type="submit" aria-label={$t("Search")}>
                    <Search className="h-5 w-5 fill-grey-usp text-white lg:h-4 lg:w-4 lg:text-grey-icon"/>
                </button>
                <Popover open={isSearchShown} onOpenChange={setIsSearchShown}>
                    <PopoverTrigger>
                        <input name="search" type="text" placeholder={$t("Find inspiration or products")} className="w-full flex-1 pl-2 text-grey-icon focus:outline-0 lg:p-0" onChange={(e) => setSearchTerm(e.target.value)}/>
                    </PopoverTrigger>
                    <PopoverContent onOpenAutoFocus={(e) => e.preventDefault()} align="end" className="-mt-1.25 max-h-[80vh] w-screen overflow-y-auto rounded-none p-0 lg:mt-1.25 lg:w-[400px]">
                        <div>
                            {((_a = suggestions === null || suggestions === void 0 ? void 0 : suggestions.searchPhrases) === null || _a === void 0 ? void 0 : _a.length) ? (<div>
                                    {suggestions.searchPhrases.map((i) => (<div key={i.name}>
                                            {i.name ? (<div className="bg-grey-bg p-3 text-sm font-semibold tracking-3">
                                                    {i.name}
                                                </div>) : null}
                                            <div>
                                                {i.suggestions.slice(0, 5).map((item, i) => (<Link onClick={() => setIsSearchShown(false)} href={`/search?tn_q=${item.match}`} className="block w-full p-3 text-sm hover:bg-gray-bg hover:text-orange-main" key={i}>
                                                        {item.match}
                                                    </Link>))}
                                            </div>
                                        </div>))}
                                </div>) : (<></>)}
                            {((_b = suggestions === null || suggestions === void 0 ? void 0 : suggestions.categories) === null || _b === void 0 ? void 0 : _b.length) ? (<div>
                                    {suggestions.categories.map((i) => (<div key={i.name}>
                                            {i.name ? (<div className="bg-grey-bg p-3 text-sm font-semibold tracking-3">
                                                    {i.name}
                                                </div>) : null}
                                            <div>
                                                {i.suggestions.slice(0, 5).map((item, i) => (<Link onClick={() => setIsSearchShown(false)} href={item.navigationLink.context.category.link} className="block w-full p-3 text-sm hover:bg-gray-bg hover:text-orange-main" key={i}>
                                                        {item.navigationLink.context.category.parentName ? (<span className="mr-1">
                                                                {`${item.navigationLink.context.category.parentName} > `}
                                                            </span>) : null}
                                                        <span>{item.match}</span>
                                                    </Link>))}
                                            </div>
                                        </div>))}
                                </div>) : (<></>)}
                            {((_d = (_c = suggestions === null || suggestions === void 0 ? void 0 : suggestions.products) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length) ? (<div>
                                    {suggestions.products.name ? (<div className="bg-grey-bg p-3 text-sm font-semibold tracking-3">
                                            {suggestions.products.name}
                                        </div>) : null}
                                    <div>
                                        {suggestions.products.items.slice(0, 3).map((item) => (<SearchItem item={item} key={item.itemno}/>))}
                                    </div>
                                </div>) : null}
                        </div>
                    </PopoverContent>
                </Popover>
            </form>
        </div>);
};
